import styled from "styled-components";

export const ClassificationContainer = styled.div`
  .classification_sections {
    position: relative;
    left: 10px;
    top: 56px;
  }
  .classification_sections .ant-card {
    background-color: #33363c !important;
    color: #ffffff !important;
    box-shadow: none;
  }
  .classification_sections .ant-card-body {
    padding: 8px;
    height: 83vh;
  }
  .classification_sections-item label {
    gap: 5px;
  }
  .classification_sections-item span {
    padding: 0px;
    color: #55babd;
  }
  .classification_sections-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }
  .classification_sections-item {
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin-bottom: 10px;
    gap:5px;
  }

  .classification_sections-item:not(:last-child) {
    border-bottom: 1px solid #6a727c;
  }
  .classification_sections-item p {
    margin: 0px;
    line-height: normal;
  }
  .classification_sections .ant-checkbox-inner {
    background-color: transparent;
    border: 2px solid #ffffff;
  }
  .classification_sections .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #007a7a;
    border-color: #007a7a;
    border: 2px;
  }

  .classification_sections
    .ant-checkbox-indeterminate
    .ant-checkbox-inner:after {
    background-color: #007a7a;
  }

  .classification_sections .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #ffffff;
    border-color: #d9d9d9;
  }

  .classification_sections.ant-checkbox-wrapper-checked:not(
      .ant-checkbox-wrapper-disabled
    ):hover
    .ant-checkbox-inner,
  .classification_sections.ant-checkbox-checked:not(
      .ant-checkbox-disabled
    ):hover
    .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
  }

  .classification_sections.ant-checkbox-wrapper:not(
      .ant-checkbox-wrapper-disabled
    ):hover
    .ant-checkbox-inner,
  .classification_sections.ant-checkbox:not(.ant-checkbox-disabled):hover
    .ant-checkbox-inner {
    border-color: #007a7a !important;
  }

  .classification_sections.ant-checkbox-wrapper:not(
      .ant-checkbox-wrapper-disabled
    ):hover
    .ant-checkbox-checked:not(.ant-checkbox-disabled)
    .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
  }

  .classification_sections.ant-checkbox-wrapper-checked:not(
      .ant-checkbox-wrapper-disabled
    ):hover
    .ant-checkbox-inner,
  .classification_sections.ant-checkbox-checked:not(
      .ant-checkbox-disabled
    ):hover
    .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
  }

  .classification_sections
    .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
    .ant-checkbox-checked:not(.ant-checkbox-disabled)
    .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
  }
  .classification_sections
    .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
    .ant-checkbox-inner,
  .classification_sections
    .ant-checkbox:not(.ant-checkbox-disabled):hover
    .ant-checkbox-inner {
    border-color: #007a7a !important;
  }

  .classification_sections span.ant-checkbox-inner:hover {
    border-color: #ffffff !important;
  }
`;
